<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: [],
      required: true
    },
    hasDefault: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: ''
    }
  },
  data() {
    return {
      value: null
    }
  },
  computed: {
    radioGroupNameId() {
      return 'radio-group-' + this.index
    }
  },
  mounted() {
    if (this.hasDefault) {
      for (let _option of this.options) {
        if (_option.default) {
          this.value = _option.text
        }
      }
    }
  },
  methods: {
    onChange(val) {
      this.value = val
      this.$emit('propChange', { value: this.value })
    },
    radiochecked(defaltValue) {
      return this.hasDefault && defaltValue
    }
  }
}
</script>
<template>
  <f7-list class="radio-list inputs-list">
    <f7-list-item :title="label" group-title></f7-list-item>
    <f7-list-item radio :name="radioGroupNameId"
      v-for="(option, index) in options"
      :key="index"
      :title="option.text"
      :checked="radiochecked(option.default)"
      v-model="option.text"
      @change="onChange(option.text, index)">
    </f7-list-item>
  </f7-list>
</template>

<style scoped>
  .list {
    margin: 15px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/form-control/RadioGroup.vue